/**
 * Created by sagardesai on 20/06/18.
 */

import {NOTIFICATION_LIST_REQUEST,NOTIFICATION_LIST_RECEIVE,NOTIFICATION_LIST_RESET, NOTIFICATION_LIST_FAILURE } from "./types";


export const requestNotificationList = () => ({
    type: NOTIFICATION_LIST_REQUEST,
    payload: null
});

export const setNotificationList = (data) => ({
    type: NOTIFICATION_LIST_RECEIVE,
    payload: data
});

export const resetNotificationList = () => ({
    type: NOTIFICATION_LIST_RESET,
    payload: null
});

export const resetNotificationListError = (error) => ({
    type: NOTIFICATION_LIST_FAILURE,
    payload: {
        error: error
    }
});

